<!-- 弹窗组件 -->
<template>
  <div v-if="modelValue" class="modal-overlay" @click.self="handleOverlayClick">
    <div class="modal-content">
      <div v-if="showIcon" class="modal-icon">
        <slot name="icon">
          <img :src="iconSrc" alt="" v-if="iconSrc">
          <img src="./success.png" alt="" v-else-if="status === 'success'">
          <img src="./error.png" alt="" v-else>
        </slot>
      </div>
      <div class="modal-title">{{ title }}</div>
      <div class="modal-description">
        <span class="modal-description" v-if="description">{{ description }}</span>
        <span class="modal-description" v-if="billingAddress" style="margin-top: 4px;">
          {{ $t('message.checkout.billingAddressTip', { billingAddress: billingAddress }) }}
        </span>
      </div>
      <div class="modal-divider" v-if="redirectUrl"></div>
      <slot></slot>
      <div class="modal-button-container" v-if="redirectUrl">
        <on-button @click="handleButtonClick" :customStyle="buttonStyle">{{ buttonText }}</on-button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'Modal',
  props: {
    modelValue: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: '',
    },
    description: {
      type: String,
      default: '',
    },
    status: {
      type: String,
      default: 'success',
    },
    showIcon: {
      type: Boolean,
      default: true,
    },
    showButton: {
      type: Boolean,
      default: true,
    },
    buttonText: {
      type: String,
      default() {
        return this.$t('message.checkout.returnMerchant');
      },
    },
    closeOnOverlayClick: {
      type: Boolean,
      default: true,
    },
    redirectUrl: {
      type: String,
      default: '',
    },
    iconSrc: {
      type: String,
      default: '',
    },
    billingAddress: {
      type: String,
      default: '',
    },
  },
  computed: {
    ...mapGetters(['app']),
    buttonStyle() {
      return {
        width: 'auto',
        minWidth: '160px',
        maxWidth: '100%',
        padding: '8px 24px',
      };
    },
  },
  watch: {
    modelValue(val) {
      if (val) {
        document.body.style.overflow = 'hidden';
      } else {
        document.body.style.overflow = '';
      }
    },
  },
  methods: {
    handleOverlayClick() {
      if (this.closeOnOverlayClick) {
        this.$emit('update:modelValue', false);
      }
    },

    handleButtonClick() {
      this.$emit('button-click');
      if (this.redirectUrl) {
        window.location.href = this.redirectUrl;
      } else {
        this.$emit('update:modelValue', false);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(102, 112, 133, 0.7);
  z-index: 10000;
  display: flex;
  justify-content: center;
  align-items: center;
  backdrop-filter: blur(10px);
}

.modal-content {
  background: #FFFFFF;

  width: 600px;
  top: 265px;

  border-radius: 18px;
  border-width: 1px;
  padding: 24px;

}

.modal-icon {
  // margin: 0 auto 16px;
  width: 40px;
  height: 40px;
  padding: 4px;
  margin-bottom: 24px;

  img {
    width: 100%;
    height: 100%;
  }
}

.modal-title {

  text-align: left;
  font-family: Open Sans regular;
  font-weight: 600;
  font-size: 20px;
  line-height: 30px;
  letter-spacing: 0px;
  margin-bottom: 24px;
  color: rgba(26, 32, 44, 1);

}

.modal-description {
  margin-bottom: 24px;
  text-align: left;

  font-family: Open Sans regular;
  font-weight: 400;
  font-size: 14px;
  line-height: 18px;
  letter-spacing: 0px;
  color: rgba(102, 112, 133, 1);
}

.modal-divider {
  height: 1px;
  background: rgba(239, 239, 244, 1);
  margin-bottom: 17px;
}

.modal-button-container {
  display: flex;
  justify-content: end;
  margin-top: 20px;
}

</style>
